module.exports = __webpack_public_path__ + "static/media/Attestazioni.a2a21303.pdf";